import { AppNav } from "./AppNav";
import { MainHeaderProps } from "./types";

/**
 * Kept for its many call sites; every main screen now shares the
 * design-system AppNav in its fixed configuration.
 */
export const MainHeader = (_props: MainHeaderProps) => {
  return <AppNav fixed />;
};
